export default __webpack_public_path__ + "static/media/screenpng.408ef6a5.png";